module.exports = __webpack_public_path__ + "d5f4369c9adffb5e0e40932c3efb15be.png";